import z from "zod";

import { SUBSCRIPTION_VENDOR } from "@/shared/domains/subscriptions/enums";

export const Document = z.object({
  id: z.string(),
  name: z.string(),
  createdAt: z.iso.datetime({ offset: true }),
  vendor: z.enum(SUBSCRIPTION_VENDOR).optional(),
});
export type Document = z.infer<typeof Document>;

export const UploadedDocument = Document.extend({ url: z.url() });
export type UploadedDocument = z.infer<typeof UploadedDocument>;
